import Axios from 'axios'
import Settings from '@/assets/scripts/settings.json'

export default {
    RemoveClassFrom(_elementselector, _classnametoremove) {
        /*=====================
        function:
        ► removes selected from cards
        =====================*/
        let elements = document.getElementsByClassName(_elementselector);
        for(var i = 0; i < elements.length; i++) {
            let item = elements[i];
            item.classList.remove(_classnametoremove);
        }
    },
    AddClassFrom(_elementselector, _classnametoremove) {
        /* =====================
        function:
        ► add selected state of all cards
        ===================== */
        let elements = document.getElementsByClassName(_elementselector);
        for (var i = 0; i < elements.length; i++) {
            let item = elements[i];
            item.classList.add(_classnametoremove);
        }
    },
    IsThereaProgress(_session, _is_local_storage) {
        /* =====================
        function:
        ► Checks if there is an existing storage from either session or local
        ===================== */
        let _isprogress = false;
        if(_is_local_storage) {
            if((localStorage.getItem(_session) != undefined) || (localStorage.getItem(_session) != null)) {
                _isprogress = true;
            }
        } else {
            if((sessionStorage.getItem(_session) != undefined) || (sessionStorage.getItem(_session) != null)) {
                _isprogress = true;
            }
        }
        return _isprogress;
    },
    ValidateProgressEntry(_session, _is_local_storage) {
        /*=====================
        function:
        ► Detects if there is a progress from the session/local storage via IsThereaProgress function
        ► Updates the object from the session storage if there is a progress
        ► Creates / Clears the object if there is no progress from session storage
        =====================*/
        let _new_session = {};
        if (this.IsThereaProgress(_session,_is_local_storage)) {
            _new_session = _is_local_storage ? JSON.parse(localStorage.getItem(_session)) : JSON.parse(sessionStorage.getItem(_session));
        } 
        return _new_session;
    },
    UpdateCurrentStep (_current_step, _number) {
        /* NEEDS MORE LOGIC
        Function: this updates the current step for both educator and service process
        Flow:
            ► Detects the current process
            ► Check the current step of the process if its currently on the same step (_number)
            ► Current step increments if its the same
        */
        if(_current_step == _number) {
            _current_step++;
        }
        return _current_step;
       
    }, 
    SessionUpdate(_session, _object, _is_local_storage, _role) {
        /*===================== 
        function:
        ► Updates / Creates session storage based on the current process used
        ► Updates / Creates session storage for process steps based on the current process used
        =====================*/
        //localStorage.setItem(_session, JSON.stringify(_object));
        //sessionStorage.setItem(_session, JSON.stringify(_object));

        if(_is_local_storage) {
            localStorage.setItem(_session, JSON.stringify(_object));
            this.UpdateSessionData(_object, _role);
        } else{
            sessionStorage.setItem(_session, JSON.stringify(_object));
        }

    },

    GoToPage(_route) {
        /* function: a much shorter and meaningful term for calling a page */
        //router.push({name: _route});  
    },
    CreateNumberArray(_starting_number, _increment_number) {
        /* function: creates an array of numbers, can be used to create days, months or years */
        let _ending_number = _starting_number + _increment_number;
        let _arr_values = [];
        for(var i = _starting_number; i <= _ending_number; i++) {
            if(i < 10) {
                _arr_values.push("0" + i);
            } else {
                _arr_values.push(i);
            }
        }
        return _arr_values;
    },
    ReturnObject(_role){
        if(_role == "educator"){
            return this.EducatorInsuranceProcess;
        }else{
            return this.ServiceInsuranceProcess;
        }
    },
    /* AXIOS COMMANDS */
    AxiosPost(_url, _data) {
        /* function: method for posting data via axios */
        return Axios({
            method: 'post',
            url: _url,
            data: _data,
            dataType: "json",
            responseType: "json",
        })
    },
    AxiosGet(_url){
        /* function: method for getting data via axios */
        return Axios({
            method: 'get',
            url: _url,
            dataType: "json",
            responseType: "json"
        })
    }, 
    AxiosPut(_url, _data){
        /* function: method for updating data via axios */
        return Axios({
            method: 'put',
            url: _url,
            data: _data,
            responseType: "json"
        })
    },
    UpdateExpiryDate(_POS_session_id, _role) {
        let expiry_date = new Date();
        let today = new Date();
        let date_modified_ = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        let today_modified = new Date()

        expiry_date.setDate(today.getDate()+30);
        let expiry_date_ = expiry_date.getFullYear() + '-' + (expiry_date.getMonth() + 1) + '-' + expiry_date.getDate();
        let url =  '/'+ _role +'/update_expiry_date.json';
        const formdata = {
            id: _POS_session_id,
            date_modified: date_modified_,
            date_expiry: expiry_date_
        }

        let UpdateExpiryDate_ = this.AxiosPut(url , formdata);

        UpdateExpiryDate_.then(response => {
            console.debug('UpdateExpiryDate response', response);
        })
        .catch(response => { 
            console.debug('UpdateExpiryDate error_response', response);
        });
    },
    /* END AXIOS COMMANDS */
    CheckSessionExpiry(_session, _expiry, _dbsessionid){
        let expiry_date = _expiry;
        let new_expiry_date = new Date(expiry_date);
        let date_today = new Date();
        let current_session_id = _dbsessionid;
        if(date_today > new_expiry_date){     
            this.UpdateIsDeletedToTrue(_dbsessionid, _session);
            return "true"
        } else {
            return "false";
        }
    },
    UpdateSessionData(_sessionobject, _role){
        /*=====================
        function:
        ► Update ```data``` column in POS ```session``` table
        ► _session (EducatorInsuranceProcess OR ServiceInsuranceProcess)
        =====================*/
        const formdata = {
            id: this.session_id,
            data: JSON.stringify(_sessionobject)
        }

        let url =  Settings.BaseURL + '/' + _role +'/update_session_data.json';
        let update_data = this.AxiosPut(url, formdata);
        update_data.then(response => { 
            console.debug("success_response", response);             
        })
        .catch(response => { 
            console.error(response);
        });
    },
    CheckSessionByReferenceNumber(ref_number, _role){
        let role = _role;
        let url =   Settings.BaseURL + '/'+ _role + '/check_quote_if_existing.json?quote_ref_num=' + ref_number;

        return this.AxiosGet(url);
    },
    AddSession(_formdata, _role){
        let url =  Settings.BaseURL + '/'+ _role + '/addsession.json';

        return this.AxiosPost(url, _formdata);
    },
    CheckQuoteIfExisting(_random_string, _role){
        let url =  Settings.BaseURL + '/'+ _role + '/check_quote_if_existing.json?quote_ref_num=' + _random_string;

        return this.AxiosGet(url);
    },
    UpdateIsDeletedToTrue(_id, _session, _role){
        /*=====================
        function:
        ► Update is_deleted in POS session table to ```true```
        ► _session (EducatorInsuranceProcess OR ServiceInsuranceProcess)
        =====================*/

        const formdata = {
                id: _id
        }
        let url =  Settings.BaseURL + '/' + _role + '/update_session_is_deleted.json';
        let UpdateIsDeletedToTrue_ = this.AxiosPut(url , formdata);
        UpdateIsDeletedToTrue_.then(response => { 
            console.debug("success_response", response);
            this.CleanStorage(_session);
            
        })
        .catch(response => { 
            console.error("UpdateIsDeletedToTrue", response);
        });
    },
    CleanStorage(_session){
        /*=====================
        function:
        ► Remove localstorage and localStorage depends on the params
        ► _session (EducatorInsuranceProcess OR ServiceInsuranceProcess)
        =====================*/

        localStorage.setItem(_session , "");
    },
    CheckSessionByEmail(_session, _object, _role) {
        //let email = this.$parent.EducatorInsuranceProcess.email_address;
        /*=====================
        function:
        ► Check ```email``` if found/exist in POS ```session``` table
        ► _session (EducatorInsuranceProcess OR ServiceInsuranceProcess)
        =====================*/

        let email = _object.Educators[0].email_address;
        let check = localStorage.getItem(_session) ? JSON.parse(localStorage.getItem(_session)) : undefined;
        let check_email = check ? check.email_address: undefined;

        //if browser has no active session/cookies
        if(check_email == undefined){
            //on blur 
            //system checks the email address for active session in DB
            let url_ = Settings.BaseURL + '/'+ _role +"/get_session_by_email.json?email_address=" + email;
            return this.AxiosGet(url_);
        } else{
            let url_ = Settings.BaseURL + '/'+ _role +"/get_session_by_email.json?email_address=" + check_email;
            return this.AxiosGet(url_);
        }
        
    },
    CreateLocalData(_role) {
        /* 
            function
                ► This is for testing purposes and needs to be removed asap only
        */
        let _insuranceprocess = {};
        if(_role == "educator") {
            let SampleEducatorProcess = {
                "package_code":"Family Day Care + In Home Care",
                "package_id":"e8bfdfa0-c211-4cd4-999c-a68dc92294c9",
                "package_id_element":"package2",
                "current_step":12,
                "additional_cover": ['Telephone Legal Advice', 'Debt Recovery service'],
                "Educators":[
                   {
                      "first_name":"Orval",
                      "last_name":"Keebler",
                      "type":"full-time educator",
                      "email_address":"mj@cbo.me",
                      "mobile_number":"0212341234",
                      "phone_number":"0212341234",
                      "date_of_birth":"1985/11/28",
                      "birth_day":"28",
                      "birth_year":"1985",
                      "birth_month":"11"
                   }
                ],
                "Addresses":[
                   {
                      "name":"Orval Keebler",
                      "street_number":"274",
                      "street_address":"05349 Senger Burg",
                      "postcode":"6175",
                      "suburb":"Consequuntur est perspiciatis alias.",
                      "state":"QLD",
                      "isselected":true
                   }
                ],
                "small_business_disclaimer":null,
                "email_address":"cbo.test13542@cbo.me",
                "mobile_number":"0292738091",
                "phone_number":"",
                "date_of_birth":"04-3-1921",
                "birth_day":"04",
                "birth_month":{
                   "text":"March",
                   "value":"3"
                },
                "birth_year":1921,
                "previous_policies":false,
                "previous_claims":false,
                "outstanding_claims":false,
                "registered_for_gst":false,
                "abn_number":"205",
                "commencement_date":"2019-5-24",
                "commencement_date_display":"24th June 2019",
                "quote_ref_num":"4ME72V",
                "coordination_unit":"Qui perspiciatis fugiat adipisci.",
                "mailing_address_id":0,
                "breakdown":{
                   "parent":{
                      "base_premium":"270.00",
                      "uw_gst":"27.00",
                      "fdca_fee":"68.84",
                      "fdca_gst":"6.88",
                      "stamp_duty":"26.73",
                      "sub_total":"399.45",
                      "type":"parent"
                   },
                   "child":{
                      "base_premium":"15.00",
                      "uw_gst":"1.50",
                      "fdca_fee":"5.00",
                      "fdca_gst":"0.50",
                      "stamp_duty":"1.49",
                      "pa_sub_total":"23.49"
                   },
                   "membership_fee":"49.90",
                   "total":472.84,
                   "additional_cover_total" : "163.90" 
                }
             };
            // let SampleEducatorProcess = {
            //     "package_code": "Family Day Care + In Home Care",
            //     "package_id": "e8bfdfa0-c211-4cd4-999c-a68dc92294c9",
            //     "package_id_element": "package2",
            //     "current_step": 12,
            //     "Educators": [
            //       {
            //         "first_name": "Orval",
            //         "last_name": "Keebler",
            //         "type": "full-time educator",
            //         "email_address": "mj@cbo.me",
            //         "mobile_number": "0212341234",
            //         "phone_number": "0212341234",
            //         "date_of_birth": "1985/11/28",
            //         "birth_day": "28",
            //         "birth_year": "1985",
            //         "birth_month": "11"
            //       }
            //     ],
            //     "Addresses": [
            //       {
            //         "name": "Orval Keebler",
            //         "street_number": "274",
            //         "street_address": "05349 Senger Burg",
            //         "postcode": "6175",
            //         "suburb": "Consequuntur est perspiciatis alias.",
            //         "state": "QLD",
            //         "isselected": true
            //       }
            //     ],
            //     "small_business_disclaimer": null,
            //     "email_address": "cbo.test13542@cbo.me",
            //     "mobile_number": "0292738091",
            //     "phone_number": "",
            //     "date_of_birth": "04-3-1921",
            //     "birth_day": "04",
            //     "birth_month": {
            //       "text": "March",
            //       "value": "3"
            //     },
            //     "birth_year": 1921,
            //     "previous_policies": false,
            //     "previous_claims": false,
            //     "outstanding_claims": false,
            //     "registered_for_gst": false,
            //     "abn_number": "205",
            //     "commencement_date": "2019-5-24",
            //     "commencement_date_display": "24th June 2019",
            //     "quote_ref_num": "4ME72V",
            //     "coordination_unit": "Qui perspiciatis fugiat adipisci.",
            //     "mailing_address_id": 0
            // }
            sessionStorage.setItem("EducatorInsuranceProcess", JSON.stringify(SampleEducatorProcess));
            localStorage.setItem("EducatorInsuranceProcess", JSON.stringify(SampleEducatorProcess));
            _insuranceprocess = SampleEducatorProcess;
        } else {

        }

        return _insuranceprocess;
    }
}